export default "__VITE_ASSET__4ae9915b__"